import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ControlLabel, Checkbox, FormGroup } from 'react-bootstrap';

class MultipleSelectInput extends Component {
  constructor(props, context) {
    super(props, context);
    var value = props.value;

    try {
      value = JSON.parse(value);
    } catch (e) {
      console.log('MultipleSelectInput::Error en el parse del objeto =>', e);
      value = null;
    }

    this.state = {
      value: value,
      options: []
    };
  }

  componentWillReceiveProps(nextProps) {
    var value;
    if (nextProps.value != null) {
      try {
        value = JSON.parse(nextProps.value);
      } catch (e) {
        console.log('MultipleSelectInput::Error en el parse del objeto =>', e);
        value = null;
      }
      this.state.value = value;
    }
  }

  componentDidMount() {
    var endpoint = null
    if (this.props.endpoint != null && !this.props.readOnly) {
      try {
        endpoint = JSON.parse(this.props.endpoint);
        if (endpoint.length > 0) {
          this.props.getOptionsEndpoint(this.props.inputId, endpoint[0]);
        }
      } catch (e) {
        endpoint = null;
      }
    }

    // setea las opciones para incorporar nuevas propiedades antes de dibujarlos
    this.setOptions();
  }

  setOptions = () => {
    const { options } = this.props;

    // se agregan nuevas propiedades al objeto para determinar si se debe mostrar la descripcion y su funcionamiento
    options.map((item) => {
      let value = item.value;
      let description = '';

      // desde value se parsea el JSON para obtener el titulo y descripcion
      try {
        let obj = JSON.parse(value);
        value = obj.title || '';
        description = obj.description || '';
      } catch(e) {
        // no hace nada, mantiene los valores de value y description declarados al comienzo del map()
      }

      // asigna y modifica los atributos de options
      item.value = value;
      item.description = description;
      item.visibleDescription = false;
      return item;
    });

    this.setState({ options });
  }

  handleVisibleDescription = (option) => {
    // modifica la propiedad al item seleccionado
    option.visibleDescription = !option.visibleDescription;

    // actualiza el state con el item modificado
    this.setState({ options: this.state.options });
  }

  render() {
    const { language } = this.props;
    var input;
    var readOnly;

    if (this.props.readOnly) {
      input = null;
      readOnly = (
        <ul className="formOnlyReadData multipleSelect">
          {this.state.value && this.state.value.map((item, i) => {
            // busca el objeto option que coincida con el valor del item
            const option = this.props.options.find(option => option.key === item);

            return (
              <li key={i}>
                <BodyComponentPrivate
                  option={option}
                  handleVisibleDescription={this.handleVisibleDescription}
                  language={language}
                >
                  <span className="multipleSelect-readOnly">{item}</span>
                </BodyComponentPrivate>
              </li>
            );
          })}
        </ul>
      );
    }
    else if (this.props.loading) {
      input = null;
      readOnly = (
        <p className="formOnlyReadData yellow">{language.tasks_manager.taskform.loadingOptions}</p>
      );
    }
    else if (this.props.status != null && this.props.status != 200) {
      input = null;
      readOnly = (
        <p className="formOnlyReadData red">{language.tasks_manager.taskform.loadingOptionsError}</p>
      );
    }
    else if (this.props.options == null) {
      input = null;
      readOnly = null;
    }
    else {
      input = (
        <div className="form-control-wrapper multipleSelect">
          {this.props.options.map((option, i) => {
            return (
              <BodyComponentPrivate
                key={i}
                option={option}
                handleVisibleDescription={this.handleVisibleDescription}
                language={language}
              >
                <Checkbox
                  value={option.key}
                  checked={this.state.value && Array.isArray(this.state.value) && this.state.value.find(item => item == option.key) ? true : false}
                  onChange={this.props.handleOnChange}
                  data-groupvalue={this.props.value ? this.props.value : "[]"}
                  data-groupid={this.props.inputId}
                >
                  {option.value}
                </Checkbox>
              </BodyComponentPrivate>
            );
          })}
        </div>
      );
      readOnly = null;
    }

    return (
      <div id={this.props.id} className={this.props.className + (this.props.error ? " invalidInput" : "")}>
        <FormGroup>
          <ControlLabel>
            {this.props.label}
            {(this.props.required && !this.props.readOnly) && (<span className="required">(*)</span>)}
          </ControlLabel>
          {readOnly}
          {input}
        </FormGroup>
        {this.props.error && (<span className={"required-message"}>{this.props.error}</span>)}
      </div>
    );
  }
}

MultipleSelectInput.propTypes = {};

export default MultipleSelectInput;

/**
 * PRIVATE COMPONENT
 */
const BodyComponentPrivate = (props) => {
  const {
    children,
    option,
    handleVisibleDescription,
    language
  } = props;
  const hasDescription = option && option.description && option.description.length > 0;

  return (
    <div>
      <div className="multipleSelect-container">
        {children}

        {
          (hasDescription) && (
            <span className="multipleSelect-visibleDescription" onClick={() => handleVisibleDescription(option)}>
              {
                (option.visibleDescription) ? language.tasks_manager.taskform.hideDescription : language.tasks_manager.taskform.showDescription
              }
            </span>
          )
        }
      </div>
      {
        (hasDescription && option.visibleDescription) && (
          <div className="animate__animated animate__fadeIn multipleSelect-description">
            {option.description}
          </div>
        )
      }
    </div>
  )
}




// WEBPACK FOOTER //
// ./source/client/components/tasks_manager/form_components/multipleSelectInput.jsx